export default {
    labels: {

        //  new
        pending_request: "Pending Request",
        createdBy: "Created By",
        slug: "Slug",
        meta_keywords: "Meta Keywords",
        export: "Export",
        characteristics: "Characteristics",
        select_characteristics: "Select Characteristics",
        payment_setting: "Payment Setting",
        payment_stripe: "Stripe Payment",
        client_id: "Client ID",
        client_secret: "Client Secret",
        currency: "Currency",
        mode: "Mode",
        sandbox: "Sandbox",
        live: "live",
        paypal: "Paypal",
        stripe: "Stripe",
        search_records: "Search...",
        famzy: 'Famzy App',
        login: 'Login',
        technologies: "Listing technologies",
        all_rights: "All rights Reserved",
        email: 'Email',
        login_button: 'Login',
        password: 'Password',
        forget_password: 'Forgot Password?',
        heading_forget: 'Forgot Password',
        heading_OTP: 'Verify OTP',
        input_otp: 'OTP',
        backto_login: 'Back to Login',
        submit: 'Submit',
        reset_password: 'Reset Password',
        new_password: 'New Password',
        confirm_password: 'Confirm Password',
        reset_pass_button: 'Reset Password',
        old_password: 'Old Password',
        new_password: 'New Password',
        new_user: 'Create New Admin',
        name: 'Name',
        designation: 'Designation',
        create_user: 'Create',
        head_admin_password: 'Change Password',
        save_password: 'Save New Password',
        admin_area: 'Admins',
        add_user: 'Add Admin',
        log_out: "Logout",
        confirm: 'Confirm',
        back: "Back",
        status: 'Status',
        action: 'Action',
        cancel: "Cancel",
        remove_image: "Remove Image",
        update: "Update",
        update_label: "Update Admin",
        add: "Add",
        age: "Age",
        save: "Save",
        select_emal: "Email Status",
        Registration_Date: "Registration Date",
        created_Date: "Inquiry Date",
        reserved: "All rights Reserved",
        delete_button: "Yes",
        copy: "COPYRIGHT ©",
        Interest: "Interests",
        languages: "Languages",
        Worklife: "Worklife",
        age_group: "Suitable year",
        role: "Role",
        Category: "Category",
        convert: "Convert",
        category: "Categories",
        subcatgory: "Sub Categories",
        in_sub__category: "Category",
        subcategory: "Sub Categories",
        select_category: "Select Category",
        select_city: "Select City",
        select_whome: "Select Whome",
        select_day: "Select Day",
        select_subcategory: "Select Sub Category",
        select_age_group: "Select Suitable year",
        select_suitable: "Select Sutaible for",
        select_date: "Select date",
        masters_settings: 'Masters & Settings',
        add_interest: 'Add Interest',
        icon: "Icon",
        edit_interest: "Edit interest",
        delete_interest: "Delete",
        delete_characteristic: "Delete",
        addUpdateinterest: "Update Interest",
        add_languages: 'Add Language',
        add_technology: 'Add Technology',
        edit_languages: "Edit language",
        edit_technology: "Edit technology",
        delete_languages: "Delete",
        addUpdatelanguages: "Update language",
        f_time: "Name",
        add_Worklife: 'Add Worklife',
        edit_Worklife: "Edit worklife",
        delete_Worklife: "Delete",
        addUpdateWorklife: "Update Worklife",
        add_age: 'Add age group',
        edit_age: "Edit age",
        delete_age: "Delete age",
        addUpdateage: "Update age",
        add_category: 'Add Category',
        edit_category: "Edit category",
        delete_category: "Delete",
        view: "View",
        addUpdatecategory: "Update category",
        category_type: "Category name",
        add_subcategory: 'Add Sub Category',
        edit_subcategory: "Edit subcategory",
        delete_subcategory: "Delete",
        addUpdatesubcategory: "Update category",
        subcategory_list: "Categories",
        event: "Events",
        place: "Places",
        class: "Class",
        services: "Service",
        remove_attachment: 'Remove Icon',
        upload_attachment: 'Upload Document',
        profile_details: " Profile Details",
        bookings: "Classes",
        places: "Places",
        class: "Classes",
        events: "Events",
        report: "Reports",
        category_type: "Category",
        parents: "Parents",
        profile_pic: " Profile Picture",
        gender: "Gender",
        Contact: "Contact Number",
        Email: "Email (verified/not verified)",
        city: "City",
        search: " Search",
        searchby: " Enter name / email",
        typeby: "Name / Email",
        entercity: " Enter City",
        typecity: "Type City",
        ageRange: "Parent age ",
        total_kids: " Total kids",
        fromDate: "Start Date",
        endDate: "End Date",
        kidsAgeRange: "Kids age",
        varified: "Verified/Unverified",
        active: "Activate",
        deactive: "Deactivate",
        reset: "Reset",
        close: "Close",
        place_details: "Place details",
        view_profile: "View Profile",
        changeStatus: "Change Status",
        gallery: "Gallery",
        p_details: "Personal Details",
        likes: " Likes",
        language: "Languages",
        Varified: "Verified",
        Unarified: "Unverified",
        bio: "Bio",
        address: " Address",
        kids: "Kids",
        worklife: "Worklife",
        k_details: "Kids Details",
        l_details: "Likes Details",
        type: "Type",
        years: "Years",
        Months: "Months",
        S_provider: "Service Providers",
        S_providerkyc: " Service Providers KYC",
        company_name: "Company Name",
        c_email: "Company Email",
        designation: "Designation",
        mobile: "Mobile",
        c_inquiry: "Contact Inquiry",
        u_name: "Name",
        e_address: "Email address",
        P_number: "Contact number",
        subject: "Subject",
        sendGDPR: "Send GDPR",
        u_details: "User Inquiry Details",
        s_details: "Service details",
        e_details: "Event Details",
        c_details: "Class Details",
        searchUser: "Search by username/email id",
        description: "Description",
        attachment: "Attachment",
        i_type: "Inquiry type",
        create_place: "Create place",
        create_service: "Create service",
        title: "Title",
        brief: "Brief",
        services: "Services",
        events: "Events",
        edit_place: "Edit Place",
        edit_class: "Edit Class",
        duplicate_class: "Create duplicate Class",
        edit_event: "Edit Event",
        edit_service: "Edit Service",
        address: "Address",
        image_upload: "Upload image",
        image_upload_here: "Upload image here",
        dragText: 'Drag images',
        t_dragText: 'Upload teachers phtoto',
        dropText: 'Drop your files here ...',
        browseText: '(or) Select Max. 5 Images',
        primaryText: 'Default',
        description: "Description",
        places: "Places",
        image: "Image",
        characteristic: "Characteristics",
        c_name: "Category",
        s_c_name: "Sub Category",
        c_t_list: "Listing type",
        s_c_t_list: "Category",
        e_c: "Edit",
        a_c: "Add characteristics",
        new: "New",
        new_notification: "App Notifications",
        view_all: "View All Notifications",
        selectEmail: "Select",
        create_place: "Create a place",
        create_class: "Create a class",
        create_event: "Create a event",
        start_time: "Start Time",
        end_time: "End Time",
        start_date: "Start date",
        end_date: "End date",
        open_time: "Opening Time",
        close_time: "Closing Time",
        brief_label: "Brief",
        brief_descrip: "Description",
        reject_reason: "Please enter the reason",
        facebook: "Facebook",
        instagram: "Instagram",
        email: "Email",
        delete_inquiry: "Delete",
        changeStatus: "Chnage",
        Instagram: "Instagram :",
        L_email: "Email : ",
        select: "Select",
        c_facebook: "Facebook : ",
        contact_details: "Contact details",
        categories_name: "Categories",
        subcategories_name: "SubCategories",
        listing_status: "Status",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        add_place: "Add place",
        avaibility: "Availability",
        block: "Block / Unblock",
        ApproveList: "Approve",
        RejectList: "Reject",
        Reject: "Reject",
        create: "Create",
        hosted_by: "Hosted By",
        createdby: "Created By :",
        hostedby: "Hosted By :",
        reviews: "Reviews",
        location: "Location",
        services_dashboard: "Services",
        places_dashboard: "Places",
        dad: "Dad",
        mom: "Mom",
        hello: "Hello,",
        male: "Male",
        female: "Female",
        kyc_type: "KYC Type",
        kyc_status: "KYC Status",
        business_tax_id: "Business tax id",
        adis_details: "Additional Details",
        basic_details: "Basic Details",
        years: "Years",
        sutaible: "Suitable year :",
        sutaible_for: "Suitable year",
        whome: "Whome",
        month: "Month",
        interest: "Interests",
        Listing_Interest: "Listing interest",
        Listing_languages: "Listing languages",
        Listing_Worklife: "Listing worklife",
        Listing_age_group: "Listing age group",
        Listing_category: "Listing category",
        Listing_subcategory: "Listing sub Category",
        Listing_characteristic: "Listing characteristics",
        admin: "Admin",
        subadmin: "Sub ADmin",
        note: "Note:",
        profile_image: "Profile",
        notification_type: "Notification category",
        notifications: "Notifications",
        today: "Today",
        tomorrow: "Tomorrow",
        week: "This week",
        teacher_details: "Teacher details",
        position: "Position*",
        s_name: "Name*",
        teacher_photo: "Upload photo",
        price: "Price* ($)",
        participants: "Participants",
        participants_list: "Participants list",
        users: "Users",
        normal: "Normal",
        recurring: "Recurring",
        for_whome: "For whome",
        alldays: "All days",
        public: "Public",
        private: "Private",
        TimeError: "Closing time should be greater than opening time",
        new_listing: "New Listing ",
        positiveList: "Listing of positive rating",
        negativeList: "Listing of negative rating",
        Dashboard: "Dashboard",
        Masters: "Masters",
        Users: "Users",
        Parents: "Parents",
        service_p: "Service Provider",
        kyc: "All KYC",
        Places: "Places",
        create_place: "Create Place",
        all_place: "All Places",
        Services: "Services",
        create_service: "Create Service",
        all_services: "All Services",
        classes: "Classes",
        create_class: "Create Class",
        all_classes: "All Classes",
        Events: "Events",
        create_event: "Create Event",
        all_events: "All Events",
        Admins: "Admins",
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thrusday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        alert_image_error: "Please upload image under 1mb!",
        reason: "Reason",
        booking_listing: "All Booking",
        booking_details: "Invoice Details",
        attendees: "Attendees",
        booked: "Bookings",
        order_number: "Order Number",
        total_amount: "Total Amount",
        payment_method: "Payment Method",
        delete_booking: "Booking",
        download_invoice: "Download invoice",
        print: "Print",
        INVOICE: "Invoice No.",
        INVOICE_DATE: "Invoice Date",
        SUBTOTAL: "SUBTOTAL",
        DISCOUNT: "DISCOUNT",
        TOTAL: "TOTAL",
        total_tax: "Total Tax",
        net_amount: "Net Amount ",
        reported_by: "Reported by",
        reported_users: "Reported Users",
        customer_name: "Customer Name :",
        payment_details: "Payment Details",
        Recipient: "Recipient",
        no_image: "No Images",
        activity: "Activity",
        deleted_users: "Deleted Users",
        inquiries: "Inquiries",
        contact_inq: "General Inquiry",
        listing_inq: "Listing Inquiry",
        contact_inqries: "General Inquiries",
        listing_inqries: "Listing Inquiries",
        reported_listing: "Reported listings",
        edit_characteristicss: "Edit characteristicss",
        search_user: "Enter users name",
        listing_report: "Reported Listing",
        reported_details: "Reported Details",
        min_age: "Minimum age",
        max_age: "Maximum age",
        interval: "Interval",
        hobi_charge: "Hobi Charge",
        service_charge: "Service Provider Charge",
        yes: "Yes",
        no: "No",
        stripe_account_id: "Stripe ID",
        r_number: "Routing Number",
        acc_number: "Account Number",
        document_front: "Front Document",
        document_back: " Back Document",
        F_name: "First Name",
        l_name: "Last Name",
        kyc_id: "Photo ID",
        n_d_available: "No data available",
        all_orders: "All Orders",
        all_bookings: "All Bookings",
        payment_method: "Payment Method",
        total_amount: "Total amount",
        order_number: "Order number",
        kidsDeetails: "Kids details",
        Payment_status: "Payment Status",
        order_details: "Order Details",
        order_no: "Order No.",
        order_DATE: "Order Date:",
        payment_by: "Payment by",
        current_orders: "Current orders",
        past_orders: "Past orders",
        bookings: "Bookings",
        searchby_id: "Order number",
        searchby_title: "Search by title",
        enterby: "Enter order no.",
        start_Date: "Start date",
        end_Date: "End date",
        order_status: "Payment Status",
        refund_percentage: "Refund percentage for customer",
        default: "(Default 97%)",
        refund: "Refund (%)",
        licence: "Licence",
        passport: "Passport",
        id_card: "Identity Card",
        resi_permit: "Residence Permit",
        dlr: "($)",
        stripe_account_id: "Stripe id",
        dob: "D.O.B",
        created_at: "Submitted date",
        class_booking: "Class Booking",
        Class_booking_list: "Class booking list",
        cancel_booking: "Cancel booking",
        f_Category: "Category*",
        f_Sub_Categories: "Sub Categories*",
        f_title: "Title*",
        f_address: "Address*",
        f_characteristics: "Characteristics*",
        f_users: "Users*",
        f_brief: "Brief (optional)",
        f_email: "Email*",
        f_name: "Name*",
        f_Description: "Description (optional)",
        f_participants: "Participants*",
        sunday_monday: "Sunday to Monday",
        refund: "Refund",
        price_ticket: "Price per ticket",
        total_bookings: "Total Bookings",
        refund_to: "Refund to customer (Percentage %)",
        Listing_claims: "Listing Claims",
        claim_listings: "All Claims",
        search_by_title: "Search by title",
        read_more: "Read more..",
        success: "success",
        service_detail: "Service detail",
        Completed: "Completed",
        claim_history: "Claim history",
        //  new strings
        tracking: "Tracking",
        device_id: "Device id",
        devicetracking: "Device Tracking",
        search_by_phone: "Email",
        last_Date: "Last Opened Date",
        testing_chart: "Testing Chart",
        device_type: "Device Type",
        device_name: "Device Name",
        mobile_model: "Mobile <odel",
        app_version: "App version",
        os_version: "OS version",
        first_opened: "First Opened",
        last_opened: "Last Opened",
        android: "Android",
        users: "Users",
        Ios: "iOS",
        Send_Notification: "Send",
        Send_Notification_text: "Send Promotional Notification",
        notification_text: "This notification will be send to",
        f_url: "Link(optional)",
        selected_users: "Selected Users",
        selected_user: "Selected User",
        all: "All",
        CountListing: "Count listings",
        Count_Listing: "Static counts",
        Ttechnologies: "Technologies",
        events: "Events",
        places: "Places",
        services: "Services",
        classes: "Classes",
        testimonials: "Testimonials",
        all_testimonials: "All testimonials",
        add_testimonials: "Add testimonials",
        edit_testimonials: "Edit testimonials",
        edit_characteristics: "Edit characteristics",
        testimonials_photo: "Upload image",
        search_name: "Enter name",
        booking_date: "Booking date",
        start_date: "Start date",
        no_kids: "No kids added",
        static: "Static",
        Verification: "Verification",
        Submit: "Submit",
        date: "Date",
        time: "Time",
        host_name: "Host Name",
        online_class: "Online Classes",
        offline_class: "Offline Classes",
        meta_tags: "Meta Tags",
        online_events: "Online Events",
        offline_events: "Offline Events",
        title_suffix: "Title suffix",
        og_image: "OG:Image",
        online_class_details: "Online Class Details",
        details: "Details",
        add_online_class: "Add Online Class",
        edit_online_class: "Edit Online Class",
        dublicate_online_class: "Duplicate Online Class",
        create_online_class: "Create Online Class",
        technology: "Technology",
        select_technology: "Select technology",
        bring_items: "What you should bring",
        takes_place_in: "Takes place in",
        refund_policy: "Refund Policy",
        CancellationDay: "1 Day",
        CancellationWeek: "1 Week",
        CancellationMonth: "1 Month",
        you_will_get: "You will get",
        of_amount: "of amount.",
        s_day: "Select day",
        permissions: "Permissions",
        permission: "Permission",
        camera: "Camera",
        notification: "Notification",
        photo_gallery: "Photo Gallery",
        location: "Location",
        accept: "Accept",
        device_model: "Device model",
        permission_type: "Permission type",
        user_bycity: "City by users",
        Delete_place: "Place deleted succesfully",
        no_photo: "No photo uploaded",
        user: "User",
        P_description: "Description*",
        birthday: "Birthday",
        uname: "User name",
        user_name: "User Name",
        Merchant_Category: "Merchant Category",
        free: "Free for parent",
        owner_address: "Onwer Address",
        owner_name: "Onwer Name",
        date_of_report: "Date of Report",
        duplicate: "Duplicate class",
        dupli_cate: "Duplicate",
        // New for
        teacher: "Teachers",
        teacher_id: "Teacher Id",
        student_id: "Student Id",
        created_at: "Created On",
        facebook_id: "Facebook Id",
        google_id: "Google Id",
        apple_id: "Apple Id",
        phone_no: "Phone No",
        certificates: "Certificates",
        experience_expertise: "Expertise",
        experience: "Experience",
        booking: "Bookings",
        class_title: "Class Title",
        event_title: "Event Title",
        category: "Category",
        mode_of_class: "Mode of Class",
        s_d_t: "Start Date and Time",
        block_button: "Block",
        block_user: "Block User",
        unblock_user: "Unblock User",
        delete_user: "Delete User",
        delete_faq: "Delete FAQ",
        delete_bug: "Delete Bug",
        delete_interest: "Delete Interest",
        interest_id: "Interest Id",
        faq: "FAQ",
        question: "Question",
        answer: "Answer",
        faqid: "FAQ Id",
        deactivate_faq: "De-Activate FAQ",
        activate_faq: "Activate FAQ",
        teacher_kyc: "Teacher's KYC",
        class_id: "Class Id",
        event_id: "Event Id",
        offline: "Offline",
        online: "Online",
        ofline:"Offline",
        investor: "Investors",
        students: "Students",
        id: "Id",
        both: "Both",
        amount: "Amount",
        teachers: 'Teachers',
        resend_otp: 'Resend OTP',
        select_mode: 'Select mode',
        select_interest: 'Select interest',
        interestt: 'Interest',
        select_exprtise: 'Select expertise',
        exprtise: 'Expertise',
        a_interest: 'Additional Interests',
        state: 'State',
        experience: 'Experience',
        listing_experience: 'Listing Experience',
        add_experience: 'Add Experience',
        delete_reported_user: "Delete Reported User",
        reported_By: "Reported By",
        created_by: "Created By",
        user_mode: "User mode",
        select_user_mode: "Select user mode",
        sr_no: "Sr No.",
        transaction_id: "Transaction Id",
        transaction_type: "Type of Transaction",
        transaction_amount: "Transaction Amount",
        transaction_time: "Transaction Time",
        transaction: "Transactions",
        transaction_typee: "Transaction type",
        select_tran_type: "Select transaction type",
        select_tran_status: "Select transaction status",
        transaction_status: "Transaction status",
        transaction_id: "Transaction Id",
        referral_total: "Total Referral",
        referred_by: "Referred By",
        payout_list: "Payout List",
        payout_details: "Payout Details",
        event_date:"Event Date",
        event_time:"Event Time",
        class_fee:"Class Fees",
        host_details:"Host Details",
        event_name:"Event Name",
        terms_help:"T & C and Privacy Policy",
        requested_classes:"Requested Classes",
        ssn_no : "SSN Number",
        start_time_utc_title : "Start time (In UTC)",
        end_time_utc_title : "End time (In UTC)",
        select_gender:"Select Gender",
        select_kyc_type:"Select KYC Type",
        select_kyc_status:"Select KYC Status",
        search_with_month:"Search with month",
        model_number:"Model Number",
        thrivecart_subscribed_users: "Thrivecart Subscribed Users",
    },

    strings: {
        image_description: " Note : Please upload Image less then 2 MB and above 800px resolution.",
        sure_deactive: "Are you sure you want to deactive this user?",
        sure_active: "Are you sure you want to activate this user?",
        sure_block_event: "Are you sure you want to block this event?",
        sure_block_class: "Are you sure you want to block this class?",
        sure_block_place: "Are you sure you want to block this place?",
        sure_block_service: "Are you sure you want to block this service?",
        sure_unblock_event: "Are you sure you want to unblock this event?",
        sure_unblock_class: "Are you sure you want to unblock this class?",
        sure_unblock_place: "Are you sure you want to unblock this place?",
        sure_unblock_service: "Are you sure you want to unblock this service?",
        sure_convert: "Are you sure you want to convert this listing?",
        sure_duplicate: "Are you sure you want to duplicate this class?",
        sure_approve: "Are you sure you want to approve this listing?",
        sure_approve_place: "Are you sure you want to approve this place?",
        sure_approve_event: "Are you sure you want to approve this event?",
        sure_approve_class: "Are you sure you want to approve this class?",
        sure_approve_service: "Are you sure you want to approve this service?",
        sure_approve_claim: "Are you sure you want to approve this claim?",
        login_account: 'Welcome! Please login to your account.',
        delete_user: 'Are you sure to delete this user ?',
        delete_parent: 'Are you sure you want to delete this parent?',
        delete_s_provider: 'Are you sure you want to delete this servivce provider?',
        DeleteLanguage: 'Are you sure you want to delete this language?',
        delete_worklife: 'Are you sure you want to delete this worklife?',
        delete_interest: 'Are you sure you want to delete this interest?',
        delete_AgeGroup: 'Are you sure you want to delete this age?',
        delete_Category: 'Are you sure you want to delete this category?',
        delete_SubCategory: 'Are you sure you want to delete this sub category?',
        block_user: 'Are you sure to block this user ?',
        unblock_user: 'Are you sure to unblock this user ?',
        delete_inquiry: 'Are you sure you want to delete this inquiry?',
        delete_language: 'Are you sure you want to delete this language?',
        delete_technology: 'Are you sure you want to delete this technology?',
        delete_place: 'Are you sure you want to delete this place?',
        delete_service: 'Are you sure you want to delete this service?',
        delete_class: 'Are you sure you want to delete this class?',
        delete_kyc: 'Are you sure you want to delete this kyc?',
        delete_event: 'Are you sure you want to delete this event?',
        delete_report: 'Are you sure you want to delete this report?',
        delete_booking: 'Are you sure you want to delete this booking?',
        delete_characteristic: 'Are you sure you want to delete characteristics?',
        note_des: "Clicking on Create will send an email to user with username and password on entered email",
        delete_testi: 'Are you sure you want to delete this testimonial?',
        deactivate_faq: 'Are you sure to De-activate this FAQ ?',
        activate_faq: 'Are you sure to Activate this FAQ ?',
        delete_faq: 'Are you sure to Delete this FAQ?',
        delete_bug: 'Are you sure to Delete this bug?',
        delete_experience: 'Are you sure you want to delete this experience?',
        delete_reported_user: 'Are you sure to delete this reported user ?',
    },

    validations: {
        url: "Please enter a valid url",
        min_first_name: "First name should be minimum 2 characters",
        min_last_name: "Last name should be minimum 2 characters",
        max_name: "Name not be greater than 30 characters",
        Teacher_name: "Please enter name",
        interest_icon_select: "please select the icon",
        enter_email: 'Please enter email',
        enter_name: 'Please enter name',
        enter_otp: 'Please enter OTP',
        otp_size: 'The OTP length must be 6 digits',
        name_validation: 'Only alphabets and space allowed',
        enter_valid_email: 'Please enter a valid email',
        enter_password: 'Please enter password',
        enter_old_password: 'Please enter old password',
        enter_confirm_password: 'Please enter confirm password',
        password_validation: 'Password should be minimum 8 characters',
        password_regex: 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)',
        confirm_password_validation: 'Confirm Password does not match with the new password, please enter the correct confirm password',
        enter_admin_new_password: 'Please enter a new password',
        enter_designation: "Please enter designation",
        interest_name: "Please enter the interest",
        testimonial_name: "Please enter the testimonial name",
        char_name: "Please enter Characteristics",
        uplaodFile: "Please upload an icon",
        language_name: "Please enter language",
        technology_name: "Please enter technology",
        language_name_alpha: "The language field should contain alphabetic character and space",
        worklife: "Please enter the worklife type",
        age: "Please select the sutaible year",
        category_name: "Please enter the category name",
        subcategory_name: "Please enter the sub category name",
        subcategory_type: "Please select categories",
        min_age: "Please select the minimum age",
        max_age: "Please select the maximum age",
        icon: "Please upload an icon",
        category_list: "Please select categories",
        characteristic_name: "Please enter characteristics name",
        InterestUploadValidation: "Please upload interest's photo",
        position: "Please enter position",
        title: "Please enter title",
        brief: "Please enter brief",
        participants: " maximum participants user",
        address: "Please enter your address",
        fileUpload_image: "Please upload image",
        description: "Please enter description",
        t_description: "Please enter description",
        slug: "Please enter  slug",
        instagram: "Please enter instagram url",
        facebook: "Please enter facebook url",
        subcategory_select: "Please select sub category",
        whome: "Please select for whome",
        day: "Please select a day",
        startDate: "Please select the start date",
        endDate: "Please select the end date",
        startTime: "Please select opening time",
        endTime: "Please select closing time",
        name: "Please enter name",
        t_name: "Please enter name",
        category_name_alpha: "The category field should contain alphabetic character and space",
        subcategory_name_alpha: "The sub category field should contain alphabetic character and space",
        interest_name_alpha: "The interest field should contain alphabetic character and space",
        testimonial_name_alpha: "The testimonial field should contain alphabetic character and space",
        characteristic_name_alpha: "The characteristic field should contain alphabetic character and space",
        postion: "Please enter position",
        position_name_alpha: "The name field should contain alphabetic position and space",
        fulltime_alpha: "The worklife field should contain alphabetic character and space",
        name_alpha: "Only alphabetic character as well as space is allowed",
        name_max: "Name not be greater than 30 characters",
        title_max: "Title name not be greater than 30 characters",
        mobile: "Please enter mobile number",
        price: "Please enter only number of price",
        users: "Please enter number of participants",
        price_digit: "Only numeric digits are allowed",
        numeric: "Only numeric digits are allowed",
        characteristics: "Please select characteristics",
        participants: "Please enter number of participants",
        between: "The vat must be between 1 and 100",
        between_charge: "The charge must be between 1 and 100",
        between_day: "The day (%) must be between 1 and 100",
        between_week: "The week (%) must be between 1 and 100",
        between_month: "The month (%) must be between 1 and 100",
        my_reason: "Please enter reason",
        max_class: "Please enter percentage",
        cancel_max: "The refund (%) must be between 1 to 100",
        // new
        Enter_reason: "Please enter reason",
        enter_client_id: "Please enter client ID",
        max_client_id: "Client ID may not be greater than 50 characters",
        enter_client_secret: "Please enter client secret",
        max_client_secret: "Client secret may not be greater than 50 characters",
        charge: "Please enter charge",
        vat: "Please enter vat percentage",
        days: "Please enter percentage of the day",
        week: "Please enter percentage of the week",
        month: "Please enter percentage of the month",
        minage_max_value: "Start year not be greater than end year",
        device_value: "Please select device",
        events_value: "Please enter event count number",
        places_value: "Please enter place count number",
        classes_value: "Please enter class count number",
        services_value: "Please enter parents count number",
        status_value: "Please select status",
        day_value: "Please select day",
        alpha_name: "Only allow contain alphabetic characters as well as spaces",
        title_suffix: "Please enter title",
        max_title_suffix: "Title may not be greater than 100 characters",
        max_bring_items: "Bring items may not be greater than 250 characters",
        technology: "Please select technology",
        otp: "Please enter 6 Digit OTP",
        question:"Please enter question for FAQ",
        answer: "Please enter answer for FAQ",
        // New
        privacy_policy:"Please enter privacy policy link",
        t_and_c: "Please enter terms and conditions link",
    }
}